//@ts-check

/**
 * Left/right arrow keys step the slideshows via the conductor.
 * One document-wide listener, attached while any slideshow is on the page.
 */
export class SlideshowKeyboard {
  /** @param {{ next: () => void, prev: () => void }} conductor */
  constructor(conductor) {
    this.conductor = conductor;
    this._onKeydown = this._onKeydown.bind(this);
    this.attached = false;
  }

  attach() {
    if (this.attached) return;
    document.addEventListener("keydown", this._onKeydown);
    this.attached = true;
  }

  detach() {
    document.removeEventListener("keydown", this._onKeydown);
    this.attached = false;
  }

  /** @param {KeyboardEvent} event */
  _onKeydown(event) {
    if (event.defaultPrevented) return;
    if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
      return;
    }
    // Don't hijack caret movement in type testers, forms, etc.
    if (isEditable(event.target)) return;

    switch (event.key) {
      case "ArrowRight":
        this.conductor.next();
        break;
      case "ArrowLeft":
        this.conductor.prev();
        break;
    }
  }
}

/** @param {EventTarget | null} target */
function isEditable(target) {
  if (!(target instanceof HTMLElement)) return false;
  return (
    target.isContentEditable ||
    target.matches("input, textarea, select, [contenteditable]")
  );
}
